// extracted by mini-css-extract-plugin
var _1 = "CourseTitle_active__3a13b";
var _2 = "CourseTitle_headerTitle__d0891";
var _3 = "CourseTitle_root__55031";
export { _1 as "active", _2 as "headerTitle", _3 as "root" }
